import { render, staticRenderFns } from "./TableTopic.vue?vue&type=template&id=4dd0407c&scoped=true&"
import script from "./TableTopic.vue?vue&type=script&lang=js&"
export * from "./TableTopic.vue?vue&type=script&lang=js&"
import style0 from "./TableTopic.vue?vue&type=style&index=0&id=4dd0407c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd0407c",
  null
  
)

export default component.exports